'use client'

import { Dialog, Cell, Text, Divider } from '@vinted/web-ui'

import { useTranslate } from '@marketplace-web/i18n/i18n-feature'
import { BusinessAddressModel } from '@marketplace-web/business-accounts/business-accounts-data'

import Address from './Address'

type Props = {
  show: boolean
  address: BusinessAddressModel | null
  onSubmit: (address: BusinessAddressModel) => void
  onCancel: () => void
}

const UboAddressModal = ({ show, address, onSubmit, onCancel }: Props) => {
  const translate = useTranslate('kyc_form.business.ubo.address.modal')

  function handleContinueClick(newAddress: BusinessAddressModel) {
    onSubmit(newAddress)
  }

  function handleCancelClick() {
    onCancel()
  }

  function renderContent() {
    return (
      <>
        <Cell>
          <div className="u-text-center">
            <Text as="h2" type="title" alignment="center" text={translate('title')} />
          </div>
        </Cell>
        <Divider />
        <Address address={address} onSubmit={handleContinueClick} onCancel={handleCancelClick} />
      </>
    )
  }

  return <Dialog show={show}>{renderContent()}</Dialog>
}

export default UboAddressModal
